import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from '../../apa/Launcher';
import Utils from "../../../utils/Utils";
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';

class LoginTask extends AbstractRequestTask {
  constructor(params = {}, body = {}, forceMwfkUrl = null) {
    super();
    this.queryParams = params;
    this.body = body;
    this.forceMwfkUrl = forceMwfkUrl;
  }

  getParams() {
    return Utils.encodeParams(this.body);
  }

  getUrl() {
    const url = this.forceMwfkUrl ? this.forceMwfkUrl : Launcher.get("akamai_mfwk");
    return `${url}/services/user/login?${this.getQueryStringParams()}`;
  }

  getMethod() {
    return 'POST';
  }

  getHeaders() {
    return {
      'Content-Type': 'application/x-www-form-urlencoded'
    };
  }

  getQueryStringParams() {
    let params = super.getParams();
    params = Object.assign({}, params, this.queryParams);
    return Utils.buildQueryParams(params);
  }

  getShowErrorModal(){
    return ENABLE_MODAL_RETRIES;
  }
}

export default LoginTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/user/LoginTask.js